import React from "react";
import { ProductFaq } from "../../../../../graphql/operations";
import FAQItem from "./FAQItem";

export type FAQsSectionProps = {
  faqs: ProductFaq[];
  addBottomBorder?: boolean;
  addTopBottomPadding?: boolean;
};

const FAQsSection: React.FC<FAQsSectionProps> = ({
  faqs,
  addBottomBorder,
  addTopBottomPadding,
}) => {
  return (
    <>
      {faqs.map((faq, index) => (
        <FAQItem
          faq={faq}
          key={faq.id}
          withBorder={addBottomBorder || index !== faqs.length - 1}
          style={{
            ...(addTopBottomPadding &&
              (index === 0
                ? {
                    paddingTop: "20px",
                  }
                : index === faqs.length - 1
                ? {
                    paddingBottom: "20px",
                  }
                : {})),
          }}
        />
      ))}
    </>
  );
};

export default FAQsSection;
